var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"poweredBy"}},[_c('span',{staticClass:"font-light d-inline-block mt-1"},[_vm._v(" Copyright © "+_vm._s(_vm.year)),_vm._v(" Sageflo, Inc. ")]),_c('span',[_vm._v("All Rights Reserved")])])
}
var staticRenderFns = []

export { render, staticRenderFns }